import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { UserRole } from '../types'
import { connectSocket, disconnectSocket } from '../socket/socketClient'

export interface User {
  id: string
  name: string
  phone?: string
  email?: string
  role: UserRole
}

interface AuthStore {
  user: User | null
  isAuthenticated: boolean
  accessToken: string | null
  setUser: (user: User, accessToken: string) => void
  setAccessToken: (token: string) => void
  clearUser: () => void
}

export const useAuthStore = create<AuthStore>()(
  persist(
    (set) => ({
      user: null,
      isAuthenticated: false,
      accessToken: null,
      setUser: (user, accessToken) => {
        set({ user, isAuthenticated: true, accessToken })
        connectSocket()
      },
      setAccessToken: (accessToken) => {
        set({ accessToken })
      },
      clearUser: () => {
        set({ user: null, isAuthenticated: false, accessToken: null })
        localStorage.removeItem('tariqgo-auth')
        disconnectSocket()
      },
    }),
    { name: 'tariqgo-auth' }
  )
)
